module.exports = __webpack_public_path__ + "static/img/produce-oversea.e68530a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/taxcellent/produce-oversea.png
// module id = Dh1o
// module chunks = 34